import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { UploadFilesService } from './upload-files.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  @ViewChild('UploadFileInput', { static: false }) uploadFileInput: ElementRef;
  fileUploadForm: UntypedFormGroup;
  fileInputLabel: string;
  genericNames: any;
  selectedGenericName: any;
  brandName: any;
  dosageList: any;
  roa: any;
  natureList: any;
  strength: any;
  selectedBrandName: any;
  selectedroa: any;
  selecteddosage: any;
  selectednature: any;
  selectedstrength: any;
  salesVolumeData: any[] = [];
  salesData = false;
  disable = false;
  tempData: any = {};
  showTable = false;
  showedit = false;
  pddGenericName: any;
  selectedpddGenericName: any;
  pddbrandName: any;
  selectedpddBrandName: any;
  pddNDA: any;
  selectedpddNDA: any;
  enteredTimes: any = '';
  enteredSamples: any = '';
  salesUpdateButton: boolean = true;
  email: any;

  constructor(
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder, public toastr: ToastrService,
    private uploadFileService: UploadFilesService
  ) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.fileUploadForm = this.formBuilder.group({
      myfile: ['']
    });
    this.getGenericNames();
    this.pddGenericNames();
  }

  onFileSelect(event) {
    let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file);
      if (!_.includes(af, file.type)) {
        alert('Only EXCEL Docs Allowed!');
      } else {
        this.fileInputLabel = file.name;
        this.fileUploadForm.get('myfile').setValue(file);
      }
    }
  }


  onFormSubmit() {
    if (!this.fileUploadForm.get('myfile').value) {
      alert('Please fill valid details!');
      return false;
    }
    const formData = new FormData();
    formData.append('file', this.fileUploadForm.get('myfile').value);
    this.uploadFileService.uploadSalesVolumeFile(formData, this.email).subscribe((response) => {
      this.toastr.success('File uploaded sucessfully', '');
    })
  }

  getGenericNames() {
    let tempGenericData: any = {
      "user_email": this.email
    }
    this.uploadFileService.getGenericNameDropdown(tempGenericData).subscribe((genericName) => {
      this.genericNames = genericName;
    })
  }

  getBrandnames() {
    let temp: any = {
      "active_ingredient": this.selectedGenericName.name
    }
    this.uploadFileService.getBrandNameDropdown(temp).subscribe((res) => {
      this.brandName = res["brand_name_list"];
    })
  }

  getROA() {
    let temp: any = {
      "active_ingredient": this.selectedGenericName.name
    }
    this.uploadFileService.getRoaDropdown(temp).subscribe((res) => {
      this.roa = res["roa_list"];
    })
  }

  getDosageNames() {
    let temp: any = {
      "active_ingredient": this.selectedGenericName.name,
      "roa": this.selectedroa.name
    }
    this.uploadFileService.getDosageDropdown(temp).subscribe((res) => {
      this.dosageList = res["dosage_list"];
    })
  }

  getNature() {
    let temp: any = {
      "active_ingredient": this.selectedGenericName.name,
      "roa": this.selectedroa.name,
      "dosage": this.selecteddosage.name
    }
    this.uploadFileService.getNatureDropdown(temp).subscribe((res) => {
      this.natureList = res["nature_list"];
    })
  }

  getStrength() {
    let temp: any = {
      "active_ingredient": this.selectedGenericName.name,
      "brand_name": this.selectedBrandName.name,
      "roa": this.selectedroa.name,
      "dosage": this.selecteddosage.name,
      "nature": this.selectednature.name
    }
    this.uploadFileService.getStrengthDropdown(temp).subscribe((res) => {
      this.strength = res["strength_list"];
    })
  }


  // getOtherDropdowns(event) {
  //   this.selectedGenericName = event.value;
  //   let dropdownData: any = {
  //     "active_ingredient": this.selectedGenericName.name
  //   }
  //   this.uploadFileService.getOtherDropdownValues(this.selectedGenericName, dropdownData).subscribe((data) => {
  //     console.log("DATA", data);
  //     this.brandName = data["brand_name_list"];
  //     this.dosageList = data["dosage_list"];
  //     this.roa = data["roa_list"];
  //     this.strength = data["strength_list"]
  //   })
  // }

  // onBrandSelection(event) {
  //   this.selectedBrandName = event.value;
  // }

  // onDosageSelection(event) {
  //   this.selecteddosage = event.value;
  // }

  // onROASelection(event) {
  //   this.selectedroa = event.value;
  // }

  // onStrengthSelection(event) {
  //   this.selectedstrength = event.value;
  // }

  showEditField() {
    this.salesData = !this.salesData;
    this.disable = !this.disable;
  }
  getSaleAndVolumeTable() {
    let salesData: any = {
      "active_ingredient": this.selectedGenericName.name,
      "roa": this.selectedroa.name,
      "dosage": this.selecteddosage.name,
      "nature": this.selectednature.name,
      "strength": this.selectedstrength.name,
      "user_email": this.email
    }
    this.uploadFileService.getSalesAndVolumeData(salesData).subscribe((salesData) => {
      console.log("SalesData", salesData)
      this.showTable = true;
      this.salesVolumeData = this.tempData = salesData;
    })
  }

  editbtn() {
    this.showedit = !this.showedit;
  }


  editdata(event, keys, Obj, index, n10) {
    console.log("event-", event, "keys-", keys, "Obj-", Obj, "index-", index, "n10-", n10)
    if (Obj !== undefined) {
      if (this.tempData[index] && Obj) {
        Obj.map((resp, j1) => {
          if (j1 === index) {
            let objkey = Object.keys(Obj[0]);
            let uniquekey = objkey[n10]
            console.log("n10", uniquekey)
            let uniquekeyList = ['YTD Oct 2017_Sales $', 'YTD Oct 2018_Sales $', 'YTD Oct 2019_Sales $', 'YTD Oct 2020_Sales $',
              'YTD Oct 2021_Sales $', 'YTD Oct 2017_NSP Ext Units', 'YTD Oct 2018_NSP Ext Units', 'YTD Oct 2019_NSP Ext Units',
              'YTD Oct 2020_NSP Ext Units', 'YTD Oct 2021_NSP Ext Units']
            // if(uniquekey === 'YTD Oct 2017_Sales $' || 'YTD Oct 2018_Sales $' || 'YTD Oct 2019_Sales $'||
            // 'YTD Oct 2020_Sales $'|| 'YTD Oct 2021_Sales $' || 'YTD Oct 2017_NSP Ext Units'|| 'YTD Oct 2018_NSP Ext Units'||
            //  'YTD Oct 2019_NSP Ext Units'|| 'YTD Oct 2020_NSP Ext Units' || 'YTD Oct 2021_NSP Ext Units'){
            if (uniquekeyList.includes(uniquekey)) {
              resp[uniquekey] = parseFloat(event.target.value);
              console.log("parsefloat", resp[uniquekey])
            }
            else {
              resp[uniquekey] = event.target.value;
              console.log("string", resp[uniquekey])
            }
          }
        })
      }
    }
  }

  updateSalesAndVolume() {
    let temp = {
      "active_ingredient": this.selectedGenericName.name,
      "brand_name": this.selectedBrandName.name,
    }
    this.uploadFileService.getNDAdropdown(temp).subscribe((res) => {
      let ndaValue = res;
      console.log("nda", res)
      let tempsss = {
        "brand_name": this.selectedBrandName.name,
        "nda": ndaValue
      }
      this.uploadFileService.getUpdateSalesVolume(tempsss).subscribe((resp) => {
        console.log("response", resp)
      })
    })
  }


  editSalesAndVolume(event: any) {

    console.log("tempdata", this.tempData)
    let updateData: any = {
      "update_dict": this.tempData,
      "active_ingredient": this.selectedGenericName.name,
      "roa": this.selectedroa.name,
      "dosage": this.selecteddosage.name,
      "strength": this.selectedstrength.name,
      "nature": this.selectednature.name
    }
    this.uploadFileService.updateSalesAndVolumeData(updateData).subscribe((updateData) => {
      this.showedit = false;
      this.toastr.success('Data saved successfully', 'Success');
      this.salesUpdateButton = false;
    })
  }

  pddGenericNames() {
    // let temp: any;
    let temp: any = {
      "user_email": this.email
    }
    this.uploadFileService.pddGenericNames(temp).subscribe(resp => {
      console.log("pdd-Generic names", resp['data'])
      this.pddGenericName = resp['data'];
    })
  }

  getpddBrandNames() {
    let temp: any = {
      "active_ing": this.selectedpddGenericName.name
    }
    this.uploadFileService.pddBrandNames(temp).subscribe(res => {
      console.log("pdd-brandname", res)
      this.pddbrandName = res['data'];
      this.pddNDA = null;
    })
  }

  getpddNDA() {
    let temp: any = {
      "active_ing": this.selectedpddGenericName.name,
      "brand_name": this.selectedpddBrandName.name
    }
    this.uploadFileService.pddNDAnumber(temp).subscribe(res => {
      console.log("pdd-NDA", res);
      this.pddNDA = res['data'];
    })
  }

  submitPDD() {
    console.log(this.selectedpddGenericName)
    if (this.selectedpddGenericName === undefined) {
      this.toastr.warning('Please select generic name', '');
    }
    else if (this.selectedpddBrandName === undefined) {
      this.toastr.warning('Please select brand name', '');
    }
    else if (this.selectedpddNDA === undefined) {
      this.toastr.warning('Please select NDA number', '');
    }
    else if (this.enteredTimes === '') {
      this.toastr.warning('Please enter value for Times (days)', '');
    }
    else if (this.enteredSamples === '') {
      this.toastr.warning('Please enter value for Samples', '');
    }
    else {
      let temp: any = {
        "active_ing": this.selectedpddGenericName.name,
        "brand_name": this.selectedpddBrandName.name,
        "nda_number": this.selectedpddNDA.name,
        "times": this.enteredTimes,
        "samples": this.enteredSamples,
        "user_email": this.email
      }
      console.log("submit pdd", temp)
      this.toastr.info('Please wait...', '');
      this.uploadFileService.pddSubmit(temp).subscribe(res => {
        this.toastr.success('Successfully submitted', '');
      })
    }
  }

  resetPDD() {
    this.selectedpddGenericName = undefined;
    this.selectedpddBrandName = undefined;
    this.selectedpddNDA = undefined;
    this.enteredTimes = "";
    this.enteredSamples = "";
  }
}
